import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import InformationIcon from '~/assets/icons/Information';
import NewMailIcon from '~/assets/icons/NewMail';

import AuthPanel from '../AuthPanel';

type Props = {
  email: string;
  warning: string;
};

export default function EmailSubmitted({ email, warning }: Props) {
  const [showNudge, setShowNudge] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setTimeout(() => setShowNudge(true), 2500);
  });

  return (
    <AuthPanel className="mt-2 gap-2 px-2 py-4 font-body">
      <div className="flex flex-col items-center justify-center gap-2">
        <NewMailIcon
          width="42"
          height="42"
          stroke="black"
          fill="none"
          circleStroke="black"
        />
        <span className="text-center text-xs text-grey-hide">
          {t('login.stageComplete.confirmationMessage', { email })}
        </span>
      </div>
      <span className="max-w-64 text-center text-base font-bold text-black">
        {t('login.stageComplete.instruction')}
      </span>

      <div
        className={`flex w-full flex-row items-center justify-center gap-2 rounded-lg bg-yellow-label p-2 text-center transition-all duration-500 ease-out ${showNudge ? 'block scale-100 opacity-100' : 'absolute scale-50 opacity-0'}`}
      >
        <InformationIcon />
        <span className="text-xs font-semibold text-black">{warning}</span>
      </div>
    </AuthPanel>
  );
}
